import { render, staticRenderFns } from "./Admin.Detail.Summary.vue?vue&type=template&id=a5121b84&"
import script from "./Admin.Detail.Summary.vue?vue&type=script&lang=js&"
export * from "./Admin.Detail.Summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports